export const ORGANIZATIONS_EDIT_FORM_NAME = 'organizationsEdit'

export const USERS_FILTER = {
  POST: 'post',
  FIRE_OUTLINE: 'fireOutline',
  FIRE_OUTLINE_PAUSED_PROTRACK: 'fireOutlinePausedProTrack',
  FIRE_OUTLINE_COMPLETED_PROTRACK: 'fireOutlineCompletedProTrack',
  ALL: 'all',
}

export const USERS_TEAM_FILTER = {
  WITHOUT: 'without',
  ALL: 'all',
}
